import * as React from "react";
import { Link } from 'gatsby';
import { Container, Navbar, Row, Col, Image, } from 'react-bootstrap';
// import CookieConsent from 'react-cookie-consent';
// import ModalPopup from "./modal-popup";

import logoWhite from '../images/logo-white.svg';
import { StaticImage } from "gatsby-plugin-image";

const Footer = () => {

  const FeaturedOnIcon = '../images/feature-on-icon1.png';

  const footerLinkMenu = [
    {
      title: "Quick Links",
      linkItem: [
        {
          slug: "/about",
          slugText: "About Us",
        },
        {
          slug: "/our-usp",
          slugText: "Our USP",
        },
        {
          slug: "/digipay-top-notch-application-security",
          slugText: "Security",
        },
        {
          slug: "/blog",
          slugText: "Blog",
        },
        {
          slug: "/contact-us",
          slugText: "Contact Us",
        },
        {
          slug: "/privacy-policy",
          slugText: "Privacy Policy",
        }
      ]
    },
    {
      title: "Solutions",
      linkItem: [
        {
          slug: "/mobile-money-payment-solutions",
          slugText: "Mobile Money",
        },
        {
          slug: "/agency-banking-solutions",
          slugText: "Agency Banking",
        },
        {
          slug: "/cross-border-payment-solutions",
          slugText: "International Remittance",
        },
        {
          slug: "/prepaid-cards-solution",
          slugText: "Cards",
        },
        {
          slug: "/ekyc-solution",
          slugText: "eKYC",
        },
        // {
        //   slug: "/scan-and-thru-solution",
        //   slugText: "Scan&Thru",
        // },
        {
          slug: "/merchant-acquiring-solution",
          slugText: "Merchant Acquiring",
        },
      ]
    },
    {
      title: "Use Cases",
      linkItem: [
        {
          slug: "/digital-fintech-solutions-for-nbfcs",
          slugText: "NBFCs",
        },
        {
          slug: "/digital-fintech-solutions-for-banks",
          slugText: "Banks",
        },
        {
          slug: "/digital-payment-solutions-for-fintechs",
          slugText: "Fintechs",
        },
        {
          slug: "/digital-fintech-solutions-for-telcos",
          slugText: "Telcos",
        }
      ]
    },
    // {
    //   title: "Reach us",
    //   linkItem: [
    //     {
    //       key: "external-link",
    //       slug: "mailto:hello@digipay.guru",
    //       slugText: "hello@digipay.guru",
    //     }
    //   ]
    // }
  ]
  const footerSoshiyalLink = [
    {
      slug: "https://www.facebook.com/digipay.guru",
      slugText: "zmdi-facebook",
      label: "facebook"
    },
    {
      slug: "https://twitter.com/DigipayGuru",
      slugText: "zmdi-twitter",
      label: "twitter"
    },
    {
      slug: "https://www.linkedin.com/company/digipay-ewallet/",
      slugText: "zmdi-linkedin",
      label: "linkedin"
    },
    {
      slug: "https://www.instagram.com/digipay.guru/",
      slugText: "zmdi-instagram",
      label: "instagram"
    },
    {
      slug: "https://www.youtube.com/channel/UC0idP2LkVrJ7lryMuWIR5DA",
      slugText: "zmdi-youtube-play",
      label: "play"
    }
  ]
  return (
    <>
      <footer className="footer">
        <div className="footer-top py-5">
          <Container>
            <Row className="justify-content-between g-4" xs={1}>
              <Col lg={3}>
                <div className="footer-about-us">
                  <div className="mb-3">
                    <Navbar.Brand>
                      <Image loading="lazy" className="lazyload" src={logoWhite} width={100} height={52} alt="logo" />
                    </Navbar.Brand>
                  </div>
                  <p className="me-5 mb-4">Digipay leverages cutting-edge technologies to offer top-notch FinTech services like real-time transfers, payments (P2P & P2M), settlements, and reconciliations.</p>
                  <div className="social-icon d-flex ms-auto">
                    {
                      footerSoshiyalLink?.map((item, index) => (
                        <a key={index} href={item.slug} aria-label={item.label} rel="noreferrer" target="_blank">
                          {item.label === "twitter" ?
                            <svg width={14} height={14} aria-hidden="true" focusable="false" data-prefix="fab" data-icon="x-twitter" className="svg-inline--fa fa-x-twitter " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg> :
                            <i className={`icon zmdi zmdi-hc-fw ${item.slugText}`}></i>
                          }
                        </a>
                      ))}

                  </div>
                </div>
              </Col>
              {footerLinkMenu?.map((item, index) => (
                <Col lg key={index}>
                  <h3 className="h4 text-white mb-3">{item.title}</h3>
                  <ul className="list-unstyled footer-menu">
                    {item.linkItem?.map((item, linkIndex) => (
                      <li key={linkIndex}>
                        {item.key === "external-link" ?
                        
                          <a href={item.slug} className="email-link">{item.slugText}</a>
                          :
                          <Link to={item.slug}>{item.slugText}</Link>
                        }
                      </li>
                    ))}
                  </ul>
                </Col>
              ))}
              <Col lg className="d-flex flex-column">
                <h3 className="h4 text-white mb-3">Reach us</h3>
                <ul className="list-unstyled footer-menu">
                  <li>
                    <a href="mailto:hello@digipay.guru" className="email-link">hello@digipay.guru</a>
                  </li>
                </ul>
                <h3 className="h4 text-white mb-4 mt-5">Certified Member on:</h3>
                <a href="https://listings.pcisecuritystandards.org/assessors_and_solutions/payment_software?reference=24-41.01559.001&agree=true" aria-label="Featured On" rel="noreferrer" target="_blank">
                  <StaticImage loading="lazy" src={FeaturedOnIcon} width={157} height={47} alt="feature-on-icon1" />
                </a>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="copyrights py-4">
          <Container className="d-flex align-items-center">
            <span className="text-white opacity-50">© 2024 DigiPay.Guru All Rights Reserved.</span>
          </Container>
        </div>
      </footer>

      <div className="sticky-cta d-grid d-md-none">
        <Link to="/contact-us" className="btn-primary-theme btn btn-lg rounded-0"><span>Get a Demo</span></Link>
      </div>

      {/* <ModalPopup /> */}

      {/* <div className="footer-cookies">
      <Container>
        <Row>
          <Col lg={10} md={12} className="mx-auto">
            <CookieConsent
              location="bottom"
              buttonText="Accept"
              declineButtonText="Decline"
              cookieName="gatsby-gdpr-google-analytics"
              containerClasses="cookies-box"
              contentClasses="text-capitalize"
              buttonClasses="btn btn-primary"
              disableStyles={true}
            >
              <h4 className="mb-3 fw-semibold font-size-22">We use cookies</h4>
              <p className="m-0"> This website uses cookies for analytics, personalization, and advertising.
                If you continue to use our website, you consent to our </p>
            </CookieConsent>
          </Col>
        </Row>
      </Container>
    </div> */}

      {/* <script type="text/javascript">
      {`_linkedin_partner_id = "4059876";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      (function(l) {
if (!l){window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
window.lintrk.q=[]}
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})(window.lintrk);`}
    </script>
    <noscript>
      {`
      <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=4059876&fmt=gif" />
      `}
    </noscript> */}
    </>
  )
}

export default Footer;
